<template>
  <d3-chart v-show="isShowExpBoxPlot"
              :options="expChartOptions"></d3-chart>
</template>

<script>
import { getPancancerExpByGene } from 'node/splicevis.js'
export default {
  name: 'GenePancancerPsi',
  data() {
    return {
      isShowExpBoxPlot: true,
      gene_name: null,
      expChartOptions: {
        chart: {
          type: 'boxplot'
        },
        title: {
          text: ''
        },
        legend: {
          enabled: false
        },
        xAxis: {
          categories: [],
          labels: {
            style: {
              'font-family': '"Roboto", sans-serif',
              'font-size': 12,
              'font-weight': '',
            }
          }
        },
        yAxis: {
          title: {
            text: 'Expression Value (log2(tpm + 0.001))',
            style: {
              'font-family': '"Roboto", sans-serif',
              'font-size': 12,
              'font-weight': '',
            }
          }
        },
        plotOptions: {
          boxplot: {
            // fillColor: '#F0F0E0',
            lineWidth: 2,
            // medianColor: '#0C5DA5',
            medianColor: '#757575',
            medianWidth: 2,
            stemColor: '#A63400',
            stemDashStyle: 'dot',
            stemWidth: 1,
            whiskerColor: '#3D9200',
            whiskerLength: '20%',
            whiskerWidth: 3,

            fillColor: null,
            colorByPoint: true,
            colors: ["#EF9A9A", "#EF9A9A", "#90CAF9", "#EF9A9A", "#90CAF9", "#EF9A9A", "#90CAF9", "#EF9A9A", "#90CAF9",
              "#EF9A9A", "#90CAF9", "#EF9A9A", "#EF9A9A", "#90CAF9", "#EF9A9A", "#EF9A9A", "#90CAF9", "#90CAF9",
              "#EF9A9A", "#EF9A9A", "#90CAF9", "#EF9A9A", "#90CAF9", "#EF9A9A", "#EF9A9A", "#90CAF9", "#EF9A9A",
              "#EF9A9A", "#90CAF9", "#EF9A9A", "#90CAF9", "#EF9A9A", "#EF9A9A", "#EF9A9A", "#90CAF9", "#EF9A9A",
              "#90CAF9", "#EF9A9A", "#90CAF9", "#EF9A9A", "#90CAF9", "#EF9A9A", "#90CAF9", "#EF9A9A", "#90CAF9",
              "#EF9A9A", "#90CAF9", "#EF9A9A", "#EF9A9A", "#90CAF9", "#EF9A9A", "#90CAF9", "#EF9A9A", "#90CAF9",
              "#EF9A9A", "#EF9A9A"],
          }
        },
        series: [{
          name: 'Expression',
          data: [],
          tooltip: {
            headerFormat: '{point.key}<br/>',
            style: {
              'font-family': 'Arial',
              'font-size': 10,
              'font-weight': 'bold',
            }
          }
        }],
        credits: {
          enabled: false
        },
      },
    }
  },
  props: {
    geneName: {
      type: String,
      default() {
        return
      }
    }
  },
  mounted() {
  },
  watch: {
    geneName(newVal, oldVal) {
      // console.log(newVal, oldVal);
      this.gene_name = newVal;
      getPancancerExpByGene(this.gene_name).then((data) => {
        // console.log(data);
        if (data && data.length > 0) {
          this.isShowExpBoxPlot = true;
          this.$emit('isshow', this.isShowExpBoxPlot)
          let categories = [];
          let boxplotData = [];
          let cancer_exp_boxplot = data[0].cancer_exp_boxplot;
          Object.keys(cancer_exp_boxplot).forEach((v, i, a) => {
            categories.push(v);
            boxplotData.push(cancer_exp_boxplot[v]);
          });

          // console.log(categories);
          // console.log(boxplotData);
          this.expChartOptions.xAxis.categories = categories;
          this.expChartOptions.series[0].data = boxplotData;
        } else {
          this.isShowExpBoxPlot = false;
          this.$emit('isshow', this.isShowExpBoxPlot)
        }
      }).catch((err) => {
        console.error(err);
      });
    }
  },
  methods: {
  },
}
</script>

<style scoped lang="sass">
.v-card__title
  line-height: 0.5rem
</style>
